import { Component, HostBinding } from '@angular/core';
import { PanelType } from '../../models/panel-type';
import { PanelComponent } from '../panel.component';

@PanelComponent.register
@Component({
  selector: 'app-spacer-panel',
  templateUrl: './spacer-panel.component.html',
  styleUrl: './spacer-panel.component.scss',
})
export class SpacerPanelComponent extends PanelComponent {
  public static override readonly type = PanelType.Spacer;
  @HostBinding('class') public class = 'col-12 mt-0';
}
